<template>
  <div :class="[$style.wrapper, active && $style.active, $style[color]]">
    <div :class="$style.window">
      <div v-if="char" :class="[$style.char, $style[char]]"></div>
      <h3 v-if="title" v-html="title"></h3>
      <p>
        <slot />
      </p>
      <v-btn :class="$style.btn" @click="() => $emit('click')">{{button}}</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'start-screen',
  props: {
    title: {
      type: String,
      default: 'Привет!',
    },
    button: {
      type: String,
      default: 'Начать',
    },
    char: {
      type: String,
      default: 'localization',
    },
    color: {
      type: String,
      default: 'blue',
    },
  },
  data: () => ({
    active: false,
  }),
  mounted() {
    setTimeout(() => { this.active = true }, 500)
  },
}
</script>
<style lang="scss" src="./style.scss" module></style>
